// @ts-ignore
import { apply, TW } from "twind";

export const resolveClasses = (defaults, custom) => {
  if (!custom) {
    return defaults;
  }

  const hash = { ...defaults };

  for (const k in defaults) {
    if (custom.hasOwnProperty(k)) {
      Object.assign(hash, { [k]: `${defaults[k]} ${custom[k]}` });
    }
  }

  return hash;
};

export const camelize = str => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

const defaultStyler = (defaultClasses, s) => {
  return defaultClasses[s] ? defaultClasses[s] : "";
};

export const hmsUiClassParserGenerator =
  ({ tw, classes, customClasses, defaultClasses, tag }) =>
  s => {
    const finalClasses = resolveClasses(defaultClasses, classes);
    if (tw) {
      return tw(
        `${tag}-${s}`,
        customClasses && customClasses[s],
        // @ts-ignore
        apply(finalClasses[s])
      );
    }
    // handle edge case of tw not being present
    else {
      return defaultStyler(defaultClasses, s);
    }
  };
